import moment from 'moment-timezone'

import { OpportunityResponse } from 'Event/interfaces/interfaceCreateEditEvent'
import { OpportunityTemplate, OpportunityTemplateRole } from 'volunteering/opportunities/interfaces'
import { mapGeofencingToEventGeofencing } from 'utils/event'
import { OpportunityVisibility, Shift } from 'Event/interfaces'
import { DEFAULT_TIME_ZONE } from 'civic-champs-shared/utils/format'
import { flatMap } from 'lodash'
import { deriveAddressTypeFromLocation } from '../../locations/helpers/location-address'

const ensureLocalTime = (value: Date | string | null | undefined, timeZone: string) =>
  value ? moment.tz(value, timeZone).format('LT') : null

export const mapEventToTemplate = (opportunity: OpportunityResponse): Omit<OpportunityTemplate, 'id'> => {
  const timeZone = opportunity.organization.timeZone || DEFAULT_TIME_ZONE

  return {
    name: opportunity.name,
    isActive: true,
    streetAddress: opportunity.address || null,
    geofencing: opportunity.geofencing ? mapGeofencingToEventGeofencing(opportunity.geofencing) : null,
    city: opportunity.city || null,
    state: opportunity.state || null,
    zip: opportunity.zip || null,
    isPrivate: opportunity.visibility === OpportunityVisibility.PRIVATE,
    isRecurring: opportunity.is_recurring || false,
    recurrencePattern: opportunity.recurrenceInfo?.pattern || null,
    visibility: opportunity.visibility,
    locationDetails: opportunity.locationDetails || null,
    contactName: opportunity.contact_name || null,
    contactEmail: opportunity.contact_email || null,
    contactPhoneNumber: opportunity.contact_phone_number || null,
    description: opportunity.description || null,
    instructions: opportunity.instructions || null,
    isSchedulable: opportunity.schedulable,
    startTime: ensureLocalTime(opportunity.startsAt, timeZone),
    endTime: ensureLocalTime(opportunity.endsAt, timeZone),
    roles: flatMap(opportunity.timeshifts, ({ roles }) =>
      roles.map(({ id, available, name }) => ({ role: { id, name }, quantity: available })),
    ),
    organizationLocationId: opportunity.locationId || null,
    organizationId: opportunity.organization.id,
    locationIsAddress: opportunity.locationIsAddress,
    locationAddressType: deriveAddressTypeFromLocation({
      locationAddressType: opportunity.locationAddressType,
      locationIsAddress: opportunity.locationIsAddress,
      locationDetails: opportunity.locationDetails,
    }),
    usageCount: 0,
    createdById: 0,
    updatedById: null,
    deletedById: null,
    createdAt: new Date(),
    updatedAt: null,
    deletedAt: null,
    order: 0,
    pointOfContactPersons: opportunity.pointOfContactPersons || [],
  }
}
